<div class="container-fluid" *ngIf="routerUrl !== '/logs'">
  <div class="row text-center">
    <div class='col-md-12'>
      <h1 style="font-size: 24px;">Oops!
        <span style="font-size: 17px; font-weight: normal; ">
          {{ commonConstant?.pageNotExist}}
        </span>
      </h1>
      <div class="error-content" >
        <div>
            <img style="max-width: 400px;" src='../../../assets/images/404er.png' alt="Page not found" />
        </div>
        <span class=" mt-2 d-inline-block">
          <a routerLink="/" class="btn btn-primary">
            <span class="fa fa-home"></span>
            {{ commonConstant?.takeMeHome}}
          </a>
        </span>
      </div>
    </div>
  </div>
</div>
<div class="container-fluid" *ngIf="routerUrl === '/logs'">
  <div class="row text-center">
    <div class='col-md-12'>
  <h1 style="font-size: 24px;">Redirecting to AppLogs. Please wait...
  </h1>
  <div>
      <span style="font-size: 17px; font-weight: normal; ">
          If not redirected 
        </span>
  <span class=" mt-2 d-inline-block">
    <a href="{{logsUrl}}" style="text-decoration: underline">
     Click here
    </a>
  </span>
</div>
</div>
</div>
</div>
